import React from "react";
import {
  Container,
  Typography,
  Box,
  AppBar,
  Toolbar,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

const RefundCancellationPolicy = () => {
  return (
    <Box>
      {/* Header */}
      <AppBar position="static">
        <Toolbar sx={{ justifyContent: "center" }}>
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" fontWeight={600}>
              BGIC Digital Store
            </Typography>
          </a>
        </Toolbar>
      </AppBar>

      {/* Content */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Typography variant="h4" gutterBottom fontWeight={600}>
          Refund & Cancellation Policy
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Last updated: 31 December 2025
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Effective: Upon publication
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography paragraph>
            This policy explains how refunds and cancellations are managed for
            payments made through{" "}
            <strong>https://www.bgicdigital.com/</strong>, operated by Bangladesh
            General Insurance Company PLC (BGIC).
          </Typography>

          {/* Section 1 */}
          <Typography variant="h6" gutterBottom>
            1. Application Fees & Premium Payments
          </Typography>
          <ul>
            <li>
              Payments made for insurance premiums, application fees, or related
              services are generally <strong>non-refundable</strong> once the
              policy is issued and coverage has commenced.
            </li>
            <li>
              Refund requests related to <strong>duplicate payment</strong>,
              <strong> failed transaction</strong>, or{" "}
              <strong>system error</strong> must be reported within{" "}
              <strong>7 (seven) working days</strong> from the payment date.
            </li>
          </ul>

          {/* Section 2 */}
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            2. Refund Eligibility
          </Typography>
          <Typography paragraph>
            Refunds may be considered under the following circumstances:
          </Typography>
          <ul>
            <li>Duplicate payment for the same policy</li>
            <li>System or technical error causing incorrect charges</li>
            <li>Payment received but insurance policy not issued</li>
            <li>
              Cancellation requested by the insured without continuation,
              provided that <strong>no claim has been reported or made</strong>
            </li>
          </ul>
          <Typography paragraph>
            All refund requests are subject to verification, underwriting
            approval, and applicable regulatory guidelines.
          </Typography>

          {/* Section 3 */}
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3. Policy Cancellation
          </Typography>
          <Typography paragraph>
            Insurance policies may be cancelled at any time during the policy
            period, subject to the terms and conditions stated in the respective
            policy document.
          </Typography>
          <Typography paragraph>
            <strong>No refund</strong> shall be applicable if any claim has been
            reported or paid under the policy.
          </Typography>

          {/* Section 3A */}
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3A. Short Period Scale (SP Scale)
          </Typography>
          <Typography paragraph>
            Where a policy is cancelled within one (1) year of commencement and
            no claim has been reported or made, premium shall be retained by
            BGIC as per the following Short Period Scale:
          </Typography>

          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><strong>Policy Period Elapsed</strong></TableCell>
                <TableCell><strong>Premium Retained</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[
                ["Up to 1 week", "20%"],
                ["Up to 1 month", "25%"],
                ["Up to 2 months", "35%"],
                ["Up to 3 months", "50%"],
                ["Up to 4 months", "60%"],
                ["Up to 6 months", "75%"],
                ["Up to 8 months", "85%"],
                ["Exceeding 8 months", "100% (No refund)"],
              ].map(([period, rate]) => (
                <TableRow key={period}>
                  <TableCell>{period}</TableCell>
                  <TableCell>{rate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Section 3B */}
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3B. Pro-Rata Basis for Policy Replacement
          </Typography>
          <Typography paragraph>
            If an insured cancels an existing policy and replaces it with another
            BGIC policy for a continuous coverage period of{" "}
            <strong>twelve (12) months</strong>, the cancellation shall be settled
            on a <strong>pro-rata basis</strong>, provided that:
          </Typography>
          <ul>
            <li>No claim has been reported or made</li>
            <li>No break in coverage occurs</li>
            <li>Underwriting and regulatory approval is obtained</li>
          </ul>

          {/* Section 4 */}
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            4. Refund Process
          </Typography>
          <ul>
            <li>
                Requests for refund due to duplicate payment, failed transaction, or system error must be submitted within <strong>7 working days</strong> from the date of payment.
              
            </li>
            <li>
              Requests for policy cancellation may be submitted at any time during the policy period, subject to policy terms and regulatory guidelines.
            </li>
            <li>
              Approved refunds shall be calculated based on the actual period of risk covered, applying either the Short Period Scale or Pro-Rata Basis, as applicable.

            </li>
            <li>
             Refunds shall be processed through the original payment method via SSLCommerz.
            </li>

            <li>
              Processing time may take 7–10 working days, depending on banking and payment gateway procedures.
            </li>

            
          </ul>

          {/* Section 5 */}
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            5. Contact Information
          </Typography>
          <Typography paragraph>
            📧 Email: info@bgicinsure.com | bgicinsurance@gmail.com
            <br />
            📞 Phone: +880 2 2233 8056–8
          </Typography>


           <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            5. Policy Udates
          </Typography>
          <Typography paragraph>
            BGIC reserves the right to modify, amend, or update this Refund & Cancellation Policy at any time. Any changes shall be effective upon publication on the Site.
          </Typography>


        </Box>
      </Container>
    </Box>
  );
};

export default RefundCancellationPolicy;









